import React from "react";
import ReactTooltip from "react-tooltip";
import Bulb from "../../assets/icons/bulb.svg";

// Styles
import "./InstructionBulb.scss";

const InstructionBulb = ({ title }) =>
  title ? (
    <>
      <ReactTooltip id="instruction-tooltip" place="bottom" effect="solid">
        {title}
      </ReactTooltip>
      <div className="instruction-bulb mr-2" data-tip data-for="instruction-tooltip">
        <img src={Bulb} height={20} width={20} alt="Instruction" />
      </div>
    </>
  ) : null;

export default InstructionBulb;
